import { ActionIcon, Tooltip } from '@mantine/core';
import { ReactNode } from 'react';
import { OverviewActionsProps } from '../type';

type IProps = {
  actions?: Array<OverviewActionsProps | ReactNode>;
  type: 'dwellings' | 'buildings' | 'lots' | 'funds' | 'portfolios';
  id: number | string;
};

function isOverviewAction(item: OverviewActionsProps | ReactNode): item is OverviewActionsProps {
  return (
    (item as OverviewActionsProps).label !== undefined &&
    (item as OverviewActionsProps).icon !== undefined
  );
}

export default function ActionsBadge({ actions, type, id }: IProps) {
  if (!actions?.length) return null;

  return (
    <span className="actions">
      {actions.map((item, index) =>
        isOverviewAction(item) ? (
          <span className="action" key={index} onClick={() => item.function?.({ type, id })}>
            <Tooltip withinPortal label={item.label} key={item.label} disabled={!item.enabled}>
              <ActionIcon variant="transparent" size="xs" disabled={!item.enabled}>
                {item.icon}
              </ActionIcon>
            </Tooltip>
          </span>
        ) : (
          <span className="action-no-padding" key={index}>
            {item}
          </span>
        )
      )}
    </span>
  );
}
